import React from 'react';
import { Spinner } from 'src/components/basic';
import SVGIcon from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import { remCss, lang, withRouter } from 'src/helpers';

import model from './modifyModel';
import LANG_CONST from 'src/helpers/lang/const';
import Advance from './Create/Advance';

class EditPatient extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    this.setState({ error: '' });

    const id = parseInt(this.props.router.params?.id);

    model.getPatient(id, (error, patient) => {
      if (error) {
        return this.setState({ error: 'NOT FOUND' });
      }
      model.setState({
        tab: 'advanced',
        patientId: id,
        firstName: patient.firstName || '',
        lastName: patient.lastName || '',
        email: patient.email || '',
        phoneNumber: patient.phoneNumber || '',
        birthday: patient.birthday || '',
        gender: patient.gender || '',
        selectedSlot: null,
        countryAddress: patient.countryAddress || '',
        stateAddress: patient.stateAddress || '',
        cityAddress: patient.cityAddress || '',
        address: patient.address || '',
        zipcode: patient.zipcode || ''
      });
    });
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }

  back = () => {
    this.navigate('/patients');
  };

  render() {
    if (
      model.getApiState('patient').loading ||
      model.state.patientId !== parseInt(this.props.router.params.id)
    )
      return (
        <div className={'mc-m-auto'}>
          <Spinner />
        </div>
      );

    return (
      <div className={'mc-container-content mc-add-patient'}>
        <div className={'mc-container-content__header mc-flex'}>
          <div className={'mc-no-style-btn'} style={{ height: remCss(40) }} onClick={this.back}>
            <SVGIcon width={40} iconname={'back-icon'} />
          </div>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.edit_patient)}</span>
        </div>
        <div className={'mc-container-content__body'}>
          {this.state.error ? (
            <span className={'mc-error'}>{this.state.error}</span>
          ) : (
            <Advance disabledRight={true} isEdit />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(EditPatient);
